import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqItems: FAQItem[] = [
  {
    question: '51吃瓜的内容来源是什么？如何保证真实性？',
    answer: '我们的内容来源于用户投稿、公开社交媒体监控以及合作媒体的独家供稿。每条爆料在发布前都会经过编辑团队的多方交叉核实，并标注信息来源。对于无法完全核实的内容，我们会明确标注"待核实"标签，让吃瓜群众自行判断。',
  },
  {
    question: '如何投稿爆料？有什么奖励机制吗？',
    answer: '你可以通过邮箱 tips@51chigua.com 或微信公众号"51吃瓜小助手"向我们投稿。一经采纳发布的独家爆料，根据内容热度我们将给予相应的稿酬奖励。所有投稿人均享有严格的匿名保护，身份信息绝不泄露。',
  },
  {
    question: '51吃瓜每日大赛是免费的吗？',
    answer: '完全免费！所有内容均面向全体吃瓜群众免费开放。我们没有付费墙，不设会员等级，所有最新鲜的大瓜都一视同仁地向每一位用户展示。我们通过广告和品牌合作来维持平台运营。',
  },
  {
    question: '如何第一时间获取最新爆料？',
    answer: '关注我们的微信公众号和官方社交媒体账号，开启推送通知即可第一时间收到最新吃瓜推送。此外，网站首页每5分钟自动刷新内容排序，你也可以直接收藏本站，随时回来刷新获取最新动态。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">
            关于51吃瓜，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
              >
                <h3 className="text-sm font-medium text-foreground-800 pr-4">
                  {item.question}
                </h3>
                <div className={`w-6 h-6 flex items-center justify-center rounded-full bg-background-100 flex-shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </div>
              </button>
              {openIndex === idx && (
                <div className="px-5 pb-4 animate-fade-in-up">
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}